//Cockpit.
import React, {useState,useEffect, Component } from "react";
// import "./style.css";
import Service from "src/api/Service";

function Cockpit(props){
  const [isLoading, setIsLoading] = useState(true);

  const [cockpit, setcockpit] = useState([]);
  const [AllChartTypes, setAllChartType] = useState({});
  function getCockPit(){
  var url= "kpiDashboard/components/"+props.client_id+"/"+props.module_id;
    Service.get(url,(status,data)=>{     
      if(status==200){
        setcockpit(data);
      }
    });
  }

  function getChartType(){
    var url= "dashboards/getChartTypes";
    Service.get(url,(status,data)=>{     
      if(status==200){
        setAllChartType(data);
        setIsLoading(false)
      }
    });
  }
  useEffect(()=>{
    getCockPit(); 
    getChartType(); 
  }, [])



    function loadComponent(name) {  
      let Component;
      try {
        Component = require('src/elements/'+name).default;
      } catch (err) {      
        Component = require('./components/TemplteError').default;
        
      }
      return Component;
    }
  
if(isLoading){
  return(
    <>
      ....
    </>
  )
}
  return (<>
   <div className="cockPit">


   {cockpit.map((item)=>{                 
          const Component = loadComponent(item.compenentType);      
            
        return(
           <>
            <div key={item.component} className="card rounded-0 componentsCard" style={{
              position:'absolute',
              width:item.width+"%",
              height:item.height+"vh",
              top: item.y+'%',
              marginBottom:'3px',
              left:item.x+'%'}}>
              <Component ChartTypes={AllChartTypes} legend={props.isChecked} name={item.compenentType} prams={item} palette={props.palette}  filterData={props.filter} countFilter={props.countFilter}/>
             </div>
           </>
        );
       })}
   </div>


 
      
   </>

  );
  
};

export default Cockpit;
